import {
    Container,
    Typography,
    Box,
    Stack,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import ReportGenerationForm from "../../components/report/ReportGenerationForm";

export default function TestSimple() {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(1234);

    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();

    // setValue(1234);

    const onExport = (queryData) => {
        console.log("Export Clicked: ", queryData); 
    }

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test Report Generation</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                    <pre>Value: {value} </pre>
                </Box>
                <ReportGenerationForm onExport={onExport} />
            </Stack>
        </Container>
    )
}
